import { IncidentDetailPage } from '@/pages/events';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_private/events/$eventUuid/incident/$incidentUuid',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <IncidentDetailPage />;
}
